import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "JustifyLeft.svg",
  "use": "JustifyLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"JustifyLeft.svg\"><path d=\"M50.0208,42.0209h-36a2,2,0,0,1,0-4h36a2,2,0,0,1,0,4Zm0-8h-36a2,2,0,1,1,0-4h36a2,2,0,0,1,0,4Zm0-8h-36a2,2,0,1,1,0-4h36a2,2,0,0,1,0,4Zm0-8h-36a2,2,0,1,1,0-4h36a2,2,0,0,1,0,4Zm-38,30a2,2,0,0,1,2-2h24a2,2,0,0,1,0,4h-24A2,2,0,0,1,12.0208,48.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol